import { useSidebar } from '~/ui/sidebar'
import { PlaylistCardNew } from './playlist-card-new'
import { cn } from '~/lib/utils'

interface PlaylistCardsProps {
  playlists?: any[]
}

export const PlaylistCards = ({ playlists }: PlaylistCardsProps) => {
  const { open } = useSidebar()
  return (
    <main className="grid place-items-center">
      <div>
        <h1 className="mb-5 text-3xl font-bold text-black sm:text-3xl md:text-3xl">Made for you</h1>
        <section
          className={cn(
            'grid grid-cols-2 gap-4 sm:grid-cols-2 md:grid-cols-3',
            { 'lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-6': open },
            { 'lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-7': !open }
          )}
        >
          {playlists?.map((playlist) => (
            <PlaylistCardNew key={playlist.id} playlist={playlist} />
          ))}
          {/* <PlaylistCardNew i={1} />
          <PlaylistCardNew i={2} />
          <PlaylistCardNew i={3} />
          <PlaylistCardNew i={4} />
          <PlaylistCardNew i={5} />
          <PlaylistCardNew i={6} />
          <PlaylistCardNew i={7} />
          <PlaylistCardNew i={8} /> */}
        </section>
      </div>
    </main>
  )
}
